import { Search, Menu, ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';
import logo from '@/assets/images/logo/logo.svg';
import { LanguageSelector } from '@/components/ui/LanguageSelector';

export const Header = () => {

  return (
    <header className="w-full bg-white/5 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Language Selector */}
          <div className="flex-shrink-0">
            <LanguageSelector />
          </div>

          {/* Centered Logo */}
          <div className="flex-1 flex justify-center">
            <img 
              src={logo} 
              alt="sOSSiety Logo" 
              className="h-8 w-auto"
            />
          </div>

          {/* Right Side - Search Icon and Menu */}
          <div className="flex items-center space-x-4">
            <button className="text-white/80 hover:text-white">
              <Search className="w-6 h-6" />
            </button>
            <button className="text-white/80 hover:text-white">
              <Menu className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
